
        import React from 'react';
        import { createRoot } from 'react-dom/client';
        import main from './agent.ts';

        const root = createRoot(document.getElementById('root'));

        async function init() {
            try {
                const appComponent = await main({ type: 'ui' }, {
                    LANGBASE_API_KEY: import.meta.env.VITE_LANGBASE_API_KEY,
                    OPENAI_API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
                });
                root.render(appComponent);
            } catch (err) {
                console.error("Failed to initialize Findsy:", err);
                root.render(React.createElement('div', { style: { padding: '20px', color: 'red' } }, 'Failed to start Findsy. Please check your connection and configuration.'));
            }
        }

        init();
    